<template>
  <v-dialog v-model="dialogVisible" max-width="800" scrollable>
    <v-card class="selection-modal">
      <v-card-title class="selection-modal__header">
        <v-icon left>mdi-office-building-marker</v-icon>
        Select a Building
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <div class="selection-modal__subtitle">
        Choose from available buildings or create a new one
        <v-btn color="primary" class="ml-4" @click="$emit('create-new')" small>
          <v-icon left>mdi-plus</v-icon>
          Create New Building
        </v-btn>
      </div>

      <!-- Search Bar -->
      <div class="selection-modal__search">
        <v-text-field
          v-model="searchQuery"
          prepend-inner-icon="mdi-magnify"
          placeholder="Search buildings..."
          outlined
          dense
          hide-details
          clearable
        ></v-text-field>
      </div>

      <v-divider></v-divider>

      <v-card-text class="selection-modal__content">
        <!-- Empty State -->
        <div v-if="filteredBuildings.length === 0" class="empty-state">
          <v-icon size="64" color="grey">mdi-office-building-outline</v-icon>
          <p v-if="searchQuery">No buildings match your search</p>
          <p v-else-if="labName">No buildings available for {{ labName }}</p>
          <p v-else>No buildings available</p>
        </div>

        <!-- Buildings -->
        <div class="buildings">
          <building-card
            v-for="building in filteredBuildings"
            :key="building.id"
            :building="building"
            :is-selected="isSelected(building.id)"
            is-selectable
            @toggle="toggleBuilding"
            class="building-card-wrapper"
          />
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="selection-modal__actions">
        <v-spacer></v-spacer>
        <v-btn text @click="close">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BuildingCard from "./BuildingCard.vue";

export default {
  name: "BuildingSelectionModal",

  components: {
    BuildingCard,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    buildings: {
      type: Array,
      default: () => [],
    },
    selectedBuildingIds: {
      type: Array,
      default: () => [],
    },
    labName: {
      type: String,
      default: null,
    },
  },

  emits: ["close", "toggle", "select", "create-new"],

  data() {
    return {
      searchQuery: "",
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("close", val);
      },
    },

    filteredBuildings() {
      if (!this.searchQuery) {
        return this.buildings;
      }
      const query = this.searchQuery.toLowerCase();
      return this.buildings.filter(
        (building) =>
          building.name?.toLowerCase().includes(query) ||
          building.description?.toLowerCase().includes(query) ||
          building.address?.toLowerCase().includes(query)
      );
    },
  },

  methods: {
    close() {
      this.searchQuery = "";
      this.$emit("close", false);
    },

    isSelected(buildingId) {
      return this.selectedBuildingIds.includes(buildingId);
    },

    toggleBuilding(building) {
      this.$emit("toggle", building);
    },
  },

  watch: {
    value(newVal) {
      if (!newVal) {
        this.selectedBuildingId = null;
        this.searchQuery = "";
      }
    },
  },
};
</script>

<style scoped>
.selection-modal {
  height: 80vh !important;
}
.selection-modal__header {
  background-color: var(--primaryColor);
  color: var(--backgroundColor) !important;
  align-items: center;
}

.selection-modal__subtitle {
  padding: 12px 16px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.selection-modal__content {
  max-height: 500px;
  overflow-y: auto;
  padding: 16px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.empty-state p {
  margin: 16px 0;
  font-size: 1.1rem;
}
</style>
